import { Button, Card, CardBody, CardHeader } from '@nextui-org/react';
import React from 'react';
import { FaFilePdf } from 'react-icons/fa6';
import { FaExternalLinkAlt } from 'react-icons/fa';

function EducationMeterial() {
  return (
    <>
      <h5 className="mb-5 text-xl md:text-3xl font-bold tracking-tight font-poppins text-gray-300 mt-[15px] md:mt-[85px]">
        Education Materials
      </h5>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">
        <Card isPressable={true} className="bg-background-secondary-color">
          <CardHeader>
            <p className="text-gray-200 text-start text-md font-medium font-poppins">
              Basic Risk Management in Forex Trading
            </p>
          </CardHeader>
          <CardBody>
            <div className="flex justify-between items-center">
              <FaFilePdf className="text-btn-color" size={40} />
              <Button
                as="a"
                href="#"
                target="_blank"
                endContent={<FaExternalLinkAlt className="text-btn-color" />}
                variant="bordered"
                color="white"
                className="text-gray-200 border-gray-300 cursor-pointer"
                onClick={(e) => {
                  e.preventDefault();
                  window.open(
                    'https://cdn.finzaid.com/pdf/Basic+Risk+Management+in+Forex+Trading-7.pdf#toolbar=0',
                    '_blank'
                  );
                }}
              >
                View
              </Button>
            </div>
          </CardBody>
          <CardBody></CardBody>
        </Card>
      </div>
    </>
  );
}

export default EducationMeterial;
